import { TProductVariantSelectInstance } from 'widgets/product/ProductVariantSelect';

import { getViewType, SMALL } from 'widgets/toolbox/viewtype';

import type { TSwiper } from 'widgets/global/CarouselSwiper';

type TProductVariantSwiper = TSwiper & {
    navigation?: {
        update: () => void;
    };
};

/**
 * @description Base MobileProductVariantSelect implementation
 * @param CarouselSwiper Base widget for extending
 * @returns MobileProductVariantSelect widget
 */
function MobileProductVariantSelectClassCreator(CarouselSwiper: import('widgets/global/CarouselSwiper').TCarouselSwiper) {
    /**
     * @category widgets
     * @subcategory product
     * @class MobileProductVariantSelect
     */
    class MobileProductVariantSelect extends CarouselSwiper {
        prefs() {
            return {
                quickView: '',
                ...super.prefs(),
                slidesPerView: 4.5,
                slidesPerViewTablet: 4.5,
                slidesPerViewMobile: 4.5,
                spaceBetween: 8,
                slidesPerGroup: 1,
                loop: false
            };
        }

        init() {
            const view = getViewType();

            if (view === SMALL && !this.prefs().quickView) {
                this.activate();
                this.eventBus().on('product.variant.changed', 'reActivate');
            }
        }

        getElement() {
            return this.items[0].ref('container').get();
        }

        changeAttribute(selectWidget: TProductVariantSelectInstance) {
            this.eventBus().emit('product.variant.change', selectWidget);
        }

        getOptions() {
            const initialSlide = this.getInitialSlide();

            return {
                ...super.getOptions(),
                slidesPerGroup: this.prefs().slidesPerGroup,
                initialSlide
            };
        }

        getInitialSlide() {
            const variationsContent = this.items[0].ref('variationsContent').get();

            if (!variationsContent) {
                return 0;
            }

            const activeVariationIndex = Array.from(variationsContent.children).findIndex(
                variation => variation.getAttribute('data-attr-is-selected') === 'true'
            );

            return activeVariationIndex >= 0 ? activeVariationIndex : 0;
        }

        reActivate() {
            this.swiper?.update();
            (this.swiper as TProductVariantSwiper)?.navigation?.update();
        }
    }

    return MobileProductVariantSelect;
}

export type TMobileProductVariantSelect = ReturnType<typeof MobileProductVariantSelectClassCreator>;

export type TMobileProductVariantSelectInstance = InstanceType<TMobileProductVariantSelect>;

export default MobileProductVariantSelectClassCreator;
